import type { CartItem } from '@backmarket/http-api/src/api-specs-checkout/cart/cart.types'

import { isBouyguesOffer } from './isBouyguesOffer'

export function hasSelectedMobilePlan(items: CartItem[]): boolean {
  return items.some((item) => {
    if (!item.mobilePlan) return false

    return isBouyguesOffer(item.mobilePlan.selectedOffer)
  })
}
